module.exports = __webpack_public_path__ + "static/img/cop_sch_logo24.5ee7608e.png";